import React from 'react';
import type { ExtractLayoutType, SharedBlockType } from '../types';
import { BlockContainer, DecorativeContainer } from '../../components/layouts';
import { AppLink, Button } from '../../components';
import styles from './styles.module.scss';
import type { PagesQuery } from '../../graphql/generated/schema';
import { constructClassName } from '../../utils/constructClassName';

export const Cta: React.FC<SharedBlockType & ExtractLayoutType<PagesQuery, 'Cta'>> = ({
  ctaContent,
  title,
  button,
  blockSettings,
}) => (
  <BlockContainer
    blockSettings={blockSettings}
  >
    <DecorativeContainer className={styles.container}>
      <h2 className={styles.title}>
        {title?.split(' ').map((word, index, array) => (
          index < array.length - 2
            ? (
              <span
                className={styles.title}
                key={index}
              >
                {word}
                {' '}
              </span>
            )
            : (
              <span
                className={constructClassName([
                  styles.title,
                  styles.secondaryTextColor,
                ])}
                key={index}
              >
                {array.slice(-2).join(' ')}
                {index === array.length - 2 && ' '}
              </span>
            )
        )).filter((_, index, array) => index < array.length - 2 || index === array.length - 2)}
      </h2>
      <p>{ctaContent}</p>
      {
        button?.buttonType && (

          <AppLink
            className={styles.link}
            link={button.link}
          >
            <Button
              htmlElement="span"
              type="primary"
            >
              {button.link?.label}
            </Button>
          </AppLink>
        )
      }
    </DecorativeContainer>
  </BlockContainer>
);
